(async () => {
  await import('./intl-get-canonical-locales');
  await import('./intl-locale');
  await import('./intl-displaynames');
})();
